import React, { useState } from 'react'
import {
  CButton,
  CForm,
  CFormInput,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import { useAuth } from '../../hooks/useAuth'
import { useToast } from '../../hooks/useToast'
import { formatErrorMessage } from '../../utils/error.utils'
import './Login.scss'

const Login = () => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const { showToast } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)

    try {
      await login(username.trim(), password)
    } catch (error) {
      const message = formatErrorMessage(error)
      showToast(message || 'Login failed. Please check your credentials.', 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="qlm-login-page">
      <div className="login-illustration">
        <img src="/images/qatar-living-logo.svg" alt="Qatar Living" className="illustration-logo" />
        
      </div>

      <div className="login-form-panel">
        <div className="login-card">
          <h2>Contents Back Office</h2>

          <CForm onSubmit={handleSubmit} className="login-form pt-4">
            <label className="form-label">Email Address</label>
            <CFormInput
              className="mb-3"
              placeholder="example@email.com"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />

            <label className="form-label">Password</label>
            <CFormInput
              className="mb-2"
              type="password"
              placeholder="Password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />


            <CButton
              type="submit"
              color="primary"
              className="login-btn mt-4"
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Login'}
            </CButton>

          </CForm>
        </div>
      </div>
    </div>
  )
}

export default Login
